var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2717 2.17413L24.643 2.1665C19.4427 2.1665 16.082 5.70832 16.082 11.1902V15.3508H11.428C11.0259 15.3508 10.7002 15.6857 10.7002 16.0988V22.1269C10.7002 22.5401 11.0262 22.8746 11.428 22.8746H16.082V38.0855C16.082 38.4986 16.4077 38.8332 16.8099 38.8332H22.8821C23.2842 38.8332 23.6099 38.4982 23.6099 38.0855V22.8746H29.0515C29.4537 22.8746 29.7793 22.5401 29.7793 22.1269L29.7816 16.0988C29.7816 15.9004 29.7047 15.7105 29.5684 15.5701C29.4321 15.4297 29.2465 15.3508 29.0534 15.3508H23.6099V11.8238C23.6099 10.1286 24.0031 9.26806 26.1528 9.26806L29.271 9.26692C29.6728 9.26692 29.9984 8.932 29.9984 8.51927V2.92179C29.9984 2.50943 29.6731 2.1749 29.2717 2.17413Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.35c01512cd033b3e731e2771713540c4.svg";
export { ForwardRef as ReactComponent };